<template>
  <div class="contain">
    <div class="info">
      <div class="info-row">
        <div class="info-logo">
          <i class="el-icon-location-outline"></i>
          <span style="margin-left: 10px"
            >{{ $t("contactUs.contactInfo.address") }}：</span
          >
        </div>
        <div class="info-content">
          {{ language === "zh" ? form.address : form.en_address }}
        </div>
      </div>

      <div class="info-row">
        <div class="info-logo">
          <i class="el-icon-postcard"></i>
          <span style="margin-left: 10px"
            >{{ $t("contactUs.contactInfo.postalCode") }}：</span
          >
        </div>
        <div class="info-content">{{ form.postal_code }}</div>
      </div>

      <div class="info-row">
        <div class="info-logo">
          <i class="el-icon-message"></i>
          <span style="margin-left: 10px">Email：</span>
        </div>
        <div class="info-content">{{ form.email }}</div>
      </div>

      <div class="info-row">
        <div class="info-logo">
          <i class="el-icon-phone-outline"></i>
          <span style="margin-left: 10px"
            >{{ $t("contactUs.contactInfo.phone") }}：</span
          >
        </div>
        <div class="info-content">{{ form.office_phone }}</div>
      </div>
    </div>
    <div class="right">
      <div>
        <baidu-map class="bm-view" :scroll-wheel-zoom="true">
          <bm-view class="map"></bm-view>
          <bm-local-search
            :keyword="form.address"
            :auto-viewport="true"
            :panel="false"
            :selectFirstResult="true"
          ></bm-local-search>
        </baidu-map>
      </div>
    </div>
  </div>
</template>

<script>
import { read } from "@/api/contactUs.js";
export default {
  data() {
    return {
      form: this.$store.getters.baseParameter,
      language: localStorage.getItem("language"),
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      read()
        .then((res) => {
          if (res.code === 0) {
            this.form = { ...res.data };
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped>
.contain {
  display: flex;
}
.info {
  width: 30%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  color: rgb(120, 123, 138);
}
.info-logo {
  margin-bottom: 10px;
}
.right {
  width: 70%;
}
.bm-view {
  width: 100%;
}
.map {
  width: 100%;
  height: 50vh;
  border-radius: 10px;
}
.info-content {
  margin-left: 25px;
}
@media only screen and (max-width: 768px) {
  .contain {
    display: block;
  }
  .info {
    width: 100%;
  }
  .info-row {
    display: flex;
  }
  .right {
    width: 100%;
  }
}
</style>